import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Injectable } from '@angular/core';
import { ConfirmationModalComponent } from 'src/app/modules/game/components/confirmation-modal/confirmation-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DialogUtilService {
  constructor(private modalService: MdbModalService) {}

  showConfirmationPrompt(text: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const modalRef = this.modalService.open(ConfirmationModalComponent, {
        modalClass: 'modal-dialog-centered'
      });

      modalRef.component.message = text;

      modalRef.onClose.subscribe((result: boolean) => {
        resolve(result || false);
      });
    });
  }

  /**
   * A choice between two real options. Resolves true / false for the buttons and null when
   * the dialog is closed otherwise (X, backdrop, Esc), so "undecided" never counts as "no".
   */
  showChoice(
    text: string,
    options: { title: string; confirmLabel: string; cancelLabel: string }
  ): Promise<boolean | null> {
    return new Promise<boolean | null>((resolve) => {
      const modalRef = this.modalService.open(ConfirmationModalComponent, {
        modalClass: 'modal-dialog-centered'
      });
      Object.assign(modalRef.component, options, { message: text, dismissResult: null });
      modalRef.onClose.subscribe((result: boolean | null | undefined) => {
        resolve(typeof result === 'boolean' ? result : null);
      });
    });
  }
}

// Legacy function for backward compatibility
let dialogUtilService: DialogUtilService | null = null;

export function setDialogUtilService(service: DialogUtilService): void {
  dialogUtilService = service;
}

export function showConfirmationPrompt(text: string): Promise<boolean> {
  if (dialogUtilService) {
    return dialogUtilService.showConfirmationPrompt(text);
  } else {
    // Fallback to simple browser confirm if service not available
    return Promise.resolve(confirm(text));
  }
}
